module.exports = __webpack_public_path__ + "static/img/img-diy-price.8cc78944.png";